import { render, staticRenderFns } from "./checkout-summary.vue?vue&type=template&id=284c7a19&scoped=true"
import script from "./checkout-summary.vue?vue&type=script&lang=js"
export * from "./checkout-summary.vue?vue&type=script&lang=js"
import style0 from "./checkout-summary.vue?vue&type=style&index=0&id=284c7a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c7a19",
  null
  
)

export default component.exports